import { UnresolvedVendorErrorCodeStatus } from '@evimo/types/enums/unresolved-vendor-error-code-status';
import { useTranslation } from 'react-i18next';
import type { SelectOption } from '~/app/components/errorManagement/UnresolvedVendorErrorCodeTab/types';

export function useUnresolvedStatusOptions(): SelectOption[] {
  const { t } = useTranslation('errorManagement');

  return Object.values(UnresolvedVendorErrorCodeStatus).map((value) => ({
    value,
    label: t(`unresolved.status.${value}`),
  }));
}
